import {Container, Graphics} from "pixi.js";
import {Vector} from "../i.js"; // ../vector.js
import {logger} from "../i.js"; // ../logger.js
import {RESOURCES, RESOURCE_INFO} from "../i.js"; // ../drop.js
import {UIUtils} from "../i.js"; // ../ui/utils.js
import {Tooltip} from "../i.js";
import {Button, ResourceDisplay} from "../i.js"; // ./button.js
import {Tab} from "../i.js"; // ./tab.js
import {ACHIEVEMENTS} from "../i.js";

export const UPGRADER_POWER = {
	NONE: 0,
	BASIC: 1,
	INTERMEDIATE: 2,
	ADVANCED: 3
};



const UPGRADE_INFO = new Map([
	["BLASTER",
		{
			name: "Blaster",
			eggDetails: (
				v => `Damage: ${v.damage}\nCooldown: ${v.cooldown}\nEnergy Cost: 1`
			),
			levels: [
				{
					value: {damage: 5, cooldown: 0.25},
					difficulty: UPGRADER_POWER.NONE,
					cost: new Map(),
					story: ""
				},
				{
					value: {damage: 6, cooldown: 0.25},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 25]
					]),
					story: "The mirrors inside the blaster have lost their shine over "
						+ "millenia of disuse. You can grind some minerals into a paste "
						+ "and use this paste to polish the mirrors, which will make "
						+ "your blaster bolts more powerful."
				},
				{
					value: {damage: 7, cooldown: 0.25},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					]),
					story: "The blaster requires high temperatures to operate. You can "
						+ "install special stones into the blaster to keep it heated "
						+ "between shots, which will make your blaster bolts more "
						+ "powerful.\n\n"
						+ "This addition technically makes your blaster a sauna. A "
						+ "danger sauna."
				},
				{
					value: {damage: 7, cooldown: 0.2},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					]),
					// This is the first time the blaster's main chamber is referred to as
					// such - the player read the schematics and learned the correct
					// terminology.
					story: "You read through the schematics of your blaster to better "
						+ "understand how it works. There is a narrow metal pipe, which "
						+ "shoots a drop of liquid into the blaster's main chamber. The "
						+ "liquid is then turned into superheated plasma, which fires "
						+ "out as the iconic blaster bolt.\n\n"
						+ "Now that you look at it, that metal pipe is too narrow - it's "
						+ "the bottleneck of the entire system! If you install a wider "
						+ "pipe, it will supply the liquid faster and improve the "
						+ "blaster's rate of fire."
					// Idea for somewhere else: duplicating that matter to avoid reloading?
					// Idea for alloys: superconducting coils to keep the plasma together
					// "You have to climb into the blaster's main chamber one more time.
					// If the blaster were to fire while you were standing there, you
					// would probably not have a great time, but that's not a fun thought."
				},
				{
					value: {damage: 8, cooldown: 0.2},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					]),
					story: ""
				},
				{
					value: {damage: 10, cooldown: 0.2},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					]),
					story: "Quality vs. quantity - a debate as old as time!\n\n"
						+ "Today, you choose quantity. You cram as many glass mirrors "
						+ "into the blaster's main chamber as you can, so that "
						+ "high-energy light can bounce between the mirrors and heat the "
						+ "plasma to greater temperatures. As you're installing the "
						+ "mirrors, you appreciate just how big this chamber is - more "
						+ "than big enough for you to walk around in it."
				},
				{
					value: {damage: 11, cooldown: 0.2},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 125]
					]),
					story: ""
				},
				{
					value: {damage: 12, cooldown: 0.2},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 250]
					]),
					story: ""
				},
				{
					value: {damage: 12, cooldown: 0.15},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.ALLOYS, 250]
					]),
					story: ""
				},
				{
					value: {damage: 13, cooldown: 0.15},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 100]
					]),
					story: ""
				},
				{
					value: {damage: 15, cooldown: 0.15},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 1000]
					]),
					story: ""
				},
				{
					value: {damage: 16, cooldown: 0.15},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {damage: 17, cooldown: 0.15},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {damage: 18, cooldown: 0.15},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {damage: 19, cooldown: 0.15},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {damage: 20, cooldown: 0.15},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				}
			]
		}
	],
	["HULL",
		{
			name: "Health",
			eggDetails: (
				v => `Hull: ${v.hull}`
			),
			levels: [
				{
					value: {hull: 25},
					difficulty: UPGRADER_POWER.NONE,
					cost: new Map(),
					story: ""
				},
				{
					value: {hull: 30},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 1]
					]),
					story: "Apparently, one of the ceramic rails in the inner layer of "
						+ "the hull is straight up missing - it just isn't there! "
						+ "Whoever originally installed those rails had one job and "
						+ "still screwed it up.\n\n"
						+ "Fortunately, you can make a new rail with just a single unit "
						+ "of minerals, and installing this rail will improve the hull "
						+ "durability by a good amount."
					// TODO: Add a chat message with "derailed" pun
				},
				{
					value: {hull: 35},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					]),
					story: ""
				},
				{
					value: {hull: 40},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					]),
					story: ""
				},
				{
					value: {hull: 45},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					]),
					story: ""
				},
				{
					value: {hull: 50},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					]),
					story: ""
				},
				{
					value: {hull: 60},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 125]
					]),
					story: ""
				},
				{
					value: {hull: 70},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 250]
					]),
					story: ""
				},
				{
					value: {hull: 80},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.ALLOYS, 250]
					]),
					story: ""
				},
				{
					value: {hull: 90},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 100]
					]),
					story: ""
				},
				{
					value: {hull: 100},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.MINERALS, 1000]
					]),
					story: ""
				},
				{
					value: {hull: 110},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {hull: 120},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {hull: 130},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {hull: 140},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {hull: 150},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				}
			]
		}
	],
	["ENGINE",
		{
			name: "Speed",
			eggDetails: (
				v => `Speed: ${v.speed}`
			),
			levels: [
				{
					value: {speed: 2},
					difficulty: UPGRADER_POWER.NONE,
					cost: new Map(),
					story: ""
				},
				{
					value: {speed: 2.2},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 25]
					]),
					story: ""
				},
				{
					value: {speed: 2.4},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					]),
					story: ""
				},
				{
					value: {speed: 2.6},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					]),
					story: ""
				},
				{
					value: {speed: 2.8},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					]),
					story: ""
				},
				{
					value: {speed: 3},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					]),
					story: ""
				},
				{
					value: {speed: 3.25},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {speed: 3.5},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 400]
					]),
					story: ""
				},
				{
					value: {speed: 3.75},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {speed: 4},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				}
			]
		}
	],
	["NANOBOTS",
		{
			name: "Nanobots",
			eggDetails: (
				v => `Heal health: ${v.heal}`
			),
			levels: [
				{
					value: {heal: 10},
					difficulty: UPGRADER_POWER.NONE,
					cost: new Map(),
					story: ""
				},
				{
					value: {heal: 12},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 25]
					]),
					story: ""
				},
				{
					value: {heal: 14},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 50]
					]),
					story: ""
				},
				{
					value: {heal: 16},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.ALLOYS, 50]
					]),
					story: ""
				},
				{
					value: {heal: 18},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.POLYMERS, 20]
					]),
					story: ""
				},
				{
					value: {heal: 20},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.MINERALS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 24},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 28},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 32},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 36},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 40},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.POLYMERS, 200]
					]),
					story: ""
				},
				{
					value: {heal: 44},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {heal: 48},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {heal: 52},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {heal: 56},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				},
				{
					value: {heal: 60},
					difficulty: UPGRADER_POWER.ADVANCED,
					cost: new Map([
						[RESOURCES.MINERALS, 1] // Placeholder
					]),
					story: ""
				}
			]
		}
	],
	["ORB",
		{
			name: "Orb",
			eggDetails: (
				v => (`Energy: ${v.energy}\nPower: ${v.power} /s\n\n`
					+ "Power is the rate at which energy regenerates "
					+ "(think physics, not anime)")
			),
			levels: [
				{
					value: {energy: 50, power: 3},
					difficulty: UPGRADER_POWER.NONE,
					cost: new Map(),
					story: ""
				},
				{
					value: {energy: 60, power: 3},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 1]
					]),
					story: "The purple energy orb, which your ship is built around, is a "
						+ "grand feat of engineering. It is already so optimized that no "
						+ "ordinary matter can improve it any further.\n\n"
						+ "But if you throw some lightweaves into the orb, perhaps you "
						+ "can make it more powerful. It's worth a try."
				},
				{
					value: {energy: 80, power: 3},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 2]
					]),
					story: "Your first batch of lightweaves unwound and dissolved in the "
					+ "orb, increasing its energy capacity. Maybe if you throw in twice "
					+ "the lightweaves, you can get twice the improvement?"
				},
				{
					value: {energy: 80, power: 4},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 3]
					]),
					story: "This time, you compress the lightweaves as much as you can "
						+ "before throwing them into the orb. Maybe if the lightweaves "
						+ "are in this different form, they will have a different effect "
						+ "on the orb?"
				},
				{
					value: {energy: 90, power: 4},
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 4]
					]),
					story: "The orb grows brighter with each upgrade, and it still "
						+ "awaits more lightweaves."
				},
				{
					value: {energy: 100, power: 4}, // TODO: Reduce Vulnerable here?
					difficulty: UPGRADER_POWER.BASIC,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 5]
					]),
					story: "You know the drill. Lightweaves, go!"
					// TODO: A note about how you should stop doing this so mindlessly
				},
				// At intermediate: start approaching the upgrades more methodically
				// "Before you throw any more lightweaves into the energy orb, you stop yourself."
				{
					value: {energy: 100, power: 5},
					difficulty: UPGRADER_POWER.INTERMEDIATE,
					cost: new Map([
						[RESOURCES.LIGHTWEAVES, 3]
					]),
					story: "As you gather more and more lightweaves, you start "
						+ "experimenting with them. You find a way to shape lightweaves "
						+ "into a fractal pattern. If any part of the pattern is "
						+ "destroyed, the remaining parts grow to replace it. If you "
						+ "make a big version of this pattern and throw it into you "
						+ "energy orb, that should increase the orb's power."
				},
				// Final lightweave sacrifice - comment on it
			]
		}
	]
]);



const POWER_NAMES = new Map([
	[UPGRADER_POWER.BASIC,        "Basic"       ],
	[UPGRADER_POWER.INTERMEDIATE, "Intermediate"],
	[UPGRADER_POWER.ADVANCED,     "Advanced"    ]
]);
const NOT_POWERFUL_ENOUGH_TEXT = "You have reached the limit of this upgrader's "
	+ "capabilities. To upgrade this technology any further, you will have to find a "
	+ "more powerful upgrader.";
const NOT_IMPLEMENTED_TEXT = "(not yet available - to be added in a future version)";
const MAXED_OUT_TEXT = "You have maxed out this technology to its perfect, ultimate "
	+ "form. There are no more upgrades to get.";



const EGG_COLORS = new Map([
	["PASSED",  UIUtils.hsv(0, 50,  90)],
	["CURRENT", UIUtils.hsv(0, 50,  90)],
	["NEXT",    UIUtils.hsv(0, 20, 100)],
	["UNKNOWN", UIUtils.hsv(0,  0,  30)]
]);

class Egg {
	constructor(tab) {
		this.tab = tab;

		this.display = new Graphics();

		this._tooltip = new Tooltip(
			tab.unicenter.game.tooltipper,
			this.display,
			"",
			"DOWN_MIDDLE"
		);
	}

	// States: one of ["PASSED", "CURRENT", "NEXT", "UNKNOWN"]
	update(dt, level, levelDetails, size, state, screenOrigin) {
		this.display
			.clear()
			.ellipse(size.x / 2, size.y / 2, size.x / 2, size.y / 2)
			.fill(EGG_COLORS.get(state));
		if (state === "NEXT") this.display
			.ellipse(
				size.x / 2, size.y / 2,
				size.x / 2 - Math.round(size.x / 6),
				size.y / 2 - Math.round(size.x / 6)
			)
			.fill(UIUtils.hsv(0, 50, 20));

		let currentText = (state === "CURRENT") ? " (current)" : ""
		if (state === "UNKNOWN") levelDetails = "???";
		this._tooltip.text = `Level ${level}${currentText}\n\n${levelDetails}`;
		this._tooltip.update(dt, screenOrigin, size);
	}
}



class Carton {
	constructor(tab) {
		this.tab = tab;

		this.display = new Container();

		this._eggs = [];
	}

	update(dt, headerHeight, upgradeBoxOrigin, upgradeBoxSize, upgrade, level) {
		let superNarrowMargin = this.tab.unicenter.requestMarginWidth(2 / 3);
		let wideMargin = this.tab.unicenter.requestMarginWidth(2);

		let numEggs = upgrade.levels.length;
		// Egg indices after which we should insert a wider margin
		let breaksAfter = [];
		for (let i = 0; i < numEggs - 1; ++i) {
			if (upgrade.levels[i].difficulty != upgrade.levels[i + 1].difficulty) {
				breaksAfter.push(i);
			}
		}
		let eggSize = new Vector(
			0.25 * headerHeight,
			0.5 * headerHeight
		).round();

		let eggsContainerOrigin = new Vector(
			numEggs * eggSize.x + (numEggs - 1) * superNarrowMargin
				+ breaksAfter.length * (wideMargin - superNarrowMargin),
			eggSize.y
		);
		let eggsContainerPosition = new Vector(
			upgradeBoxSize.x - wideMargin - eggsContainerOrigin.x,
			(headerHeight - eggsContainerOrigin.y) / 2
		).round();
		this.display.position.copyFrom(eggsContainerPosition);

		let eggX = 0;
		UIUtils.cullElements(this._eggs, numEggs);
		for (let i = 0; i < numEggs; ++i) {
			if (this._eggs.length <= i) {
				let egg = new Egg(this.tab);
				this._eggs.push(egg);
				this.display.addChild(egg.display);
			}

			let egg = this._eggs[i];

			let state = "UNKNOWN";
			if ((i === level + 1) && (upgrade.levels[i].difficulty <= this.tab.power)) {
				state = "NEXT";
			}
			if (i === level) state = "CURRENT";
			if (i < level) state = "PASSED";

			let eggScreenOrigin = new Vector(eggX, 0)
				.add(eggsContainerPosition)
				.add(upgradeBoxOrigin)
				.add(this.tab.unicenter.requestTabOrigin());

			egg.update(
				dt,
				i,
				upgrade.eggDetails(upgrade.levels[i].value),
				eggSize,
				state,
				eggScreenOrigin
			);
			egg.display.x = eggX;

			eggX += eggSize.x;
			eggX += (breaksAfter.includes(i) ? wideMargin : superNarrowMargin);
		}
	}
}



export class Upgrader extends Tab {
	// Info about nature and cost of upgrades

	// Create a new upgrader
	// Each unicenter should create exactly one upgrader.
	//
	// Args:
	//   unicenter - reference to the unicenter
	//   savefile  - optional savefile (object)
	constructor(unicenter, savefile) {
		super(unicenter,
			new Set(["Origin Station", "Grand Station"]),
			Tab.LOCATIONS.LEFT,
			"images/icons/upgrader.svg",
			0,
			"Upgrader"
		);

		// Map each tech to level 0
		this._levels = new Map(
			Array.from(UPGRADE_INFO.keys()).map(techName => [techName, 0])
		);
		// Read levels from the savefile
		let savedLevels = new Map(Object.entries(savefile?.l ?? {}));
		savedLevels.forEach((level, techName) => {
			if (!this._levels.has(techName)) return;
			if (level < 0) return;
			if (level >= UPGRADE_INFO.get(techName).levels.length) return;
			this._levels.set(techName, level);
		});

		// TODO: Move this to the forge
		this.thrustersForged = savefile?.tf ?? false;

		this.power = UPGRADER_POWER.BASIC;

		// Tech name or null
		this._selectedTech = null;

		// Visuals

		this.display.title = UIUtils.getBitmapText("", this.colorHighlight);

		this.display.resourceDisplay = new ResourceDisplay(this.unicenter);

		this._techSelectorMap = new Map();
		this.display.techSelectors = new Container();
		UPGRADE_INFO.forEach((upgrade, techName) => {
			let techButton = new Button(unicenter);
			this._techSelectorMap.set(techName, techButton);
			this.display.techSelectors.addChild(techButton);
		});

		this.display.selectTechTip = UIUtils.getBitmapText(
			"Select a technology to upgrade",
			this.colorHighlight
		);

		this.display.upgradeBox = new Graphics();

		this.display.upgradeTitle = UIUtils.getBitmapText("", this.colorHighlight);
		this.display.carton = new Carton(this);
		this.display.upgradeStory = UIUtils.getBitmapText("", this.colorHighlight,
			{wordWrap: true}
		);
		this.display.upgradeButton = new Button(unicenter);

		this.display.upgradeBox.addChild(
			this.display.upgradeTitle,
			this.display.carton.display,
			this.display.upgradeStory,
			this.display.upgradeButton
		);

		this.display.addChild(
			this.display.title,
			this.display.resourceDisplay,
			this.display.techSelectors,
			this.display.selectTechTip,
			this.display.upgradeBox
		);
	}

	// Update the upgrader
	// Call this every tick.
	//
	// Args:
	//   visible - boolean, true iff the display is visible this tick
	//   size    - vector in pixels representing the desired size of the display
	//   dt      - time since last tick, in seconds
	update(visible, size, dt) {
		if (visible) {
			this._updatePower();

			if (this.display.upgradeButton.wasClicked()) {
				this._tryUpgrade(this._selectedTech);
			}
			this._techSelectorMap.forEach((techButton, techName) => {
				if (techButton.wasClicked()) {
					this._selectedTech = (this._selectedTech === techName)
									? null : techName;
				}
			});
		}

		super.update(visible, size, dt);

		this.display.techSelectors.children.forEach(
			techButton => techButton.clearStuff()
		);
		this.display.upgradeButton.clearStuff();
	}

	save() {
		return {
			l: Object.fromEntries(this._levels),
			tf: this.thrustersForged
		};
	}

	// Get the value for an upgradable number
	// All upgrades are pulled by whatever needs them, not pushed by upgrader.
	//
	// Args:
	//   techName - string, name of the tech
	//   property - string, property of the tech to get
	getValue(techName, property) {
		if (!UPGRADE_INFO.has(techName)) {
			logger.error("upgrader.js", `unknown tech name ${techName}`);
			return 0;
		}

		let level = UPGRADE_INFO.get(techName).levels[this._levels.get(techName)];
		return level.value[property];
	}

	// Check whether the player can currently upgrade / forge anything
	anythingToDo(power) {
		for (let techName of UPGRADE_INFO.keys()) {
			let upgrade = UPGRADE_INFO.get(techName);
			let level = this._levels.get(techName);

			// Max level, upgrade impossible
			if (level === upgrade.levels.length - 1) continue;

			// Next upgrade is too diffucult, upgrade impossible
			if (upgrade.levels[level + 1].difficulty > power) continue;

			// Enough resources to upgrade, that's something to do!
			let cost = upgrade.levels[level + 1].cost;
			if (this.unicenter.refinery.canAfford(cost)) {
				return true;
			}
		}

		// Nothing to do :(
		return false;
	}

	// Max out all upgrades, used for cheats
	maxOut() {
		for (let techName of UPGRADE_INFO.keys()) {
			this._levels.set(techName, UPGRADE_INFO.get(techName).levels.length - 1)
		}
	}

	// Update the upgrader power based on what station the player is docked to
	_updatePower() {
		let dockedTo = this.unicenter.game.space.player.dockedTo();
		if (dockedTo === null) return;

		let station = this.unicenter.game.space.requestThingById(dockedTo);
		if (station === null) return;

		if (station.name === "Grand Station") {
			this.power = UPGRADER_POWER.INTERMEDIATE;
		} else {
			this.power = UPGRADER_POWER.BASIC;
		}
	}

	// Refresh the display, redrawing everything from scratch
	// This method only needs to be called when something actually changed, but
	// it's okay to call it every tick.
	_refreshDisplay(dt) {
		let size = this.display.size;
		let narrowMargin = this.unicenter.requestMarginWidth(1);
		let wideMargin = this.unicenter.requestMarginWidth(2);

		this.display.title.style.fontSize = this.unicenter.requestFontSize("LARGE");
		this.display.title.text = `${POWER_NAMES.get(this.power)} Upgrader`;

		this.display.resourceDisplay.update(
			this.colorHighlight,
			this.unicenter.refinery._resources,
			Math.round(size.y / 30)
		);
		this.display.resourceDisplay.position.copyFrom(new Vector(
			2/3 * size.x,
			0
		).round());

		let techSelectorsOrigin = new Vector(
			0,
			this.display.title.height + wideMargin
		).round();
		this.display.techSelectors.position.copyFrom(techSelectorsOrigin);

		let techButtonSize = new Vector(size.y / 10, size.y / 10).round();
		let techButtonOrigin = new Vector();
		this._techSelectorMap.forEach((techButton, techName) => {
			techButton.update(
				this.colorBase,
				this.colorHighlight,
				techButtonOrigin,
				techButtonSize,
				UPGRADE_INFO.get(techName).name[0]
			);
			techButtonOrigin.x += techButtonSize.x + narrowMargin;
		});

		let upgradeBoxOrigin = new Vector(
			0,
			techSelectorsOrigin.y + techButtonSize.y + wideMargin
		);
		let upgradeBoxSize = Vector.diff(size, upgradeBoxOrigin);

		let selectTechTip = this.display.selectTechTip;
		let upgradeBox = this.display.upgradeBox;
		if (this._selectedTech === null) {
			selectTechTip.visible = true;
			selectTechTip.style.fontSize = this.unicenter.requestFontSize("SMALL");
			selectTechTip.position.copyFrom(
				Vector.diff(
					upgradeBoxSize,
					new Vector(selectTechTip.width, selectTechTip.height)
				)
					.scale(0.5)
					.add(upgradeBoxOrigin)
					.round()
			);

			upgradeBox.visible = false;
		} else {
			selectTechTip.visible = false;

			let headerHeight = Math.round(upgradeBoxSize.y / 6);

			let upgrade = UPGRADE_INFO.get(this._selectedTech);
			let level = this._levels.get(this._selectedTech);

			upgradeBox.visible = true;
			upgradeBox.position.copyFrom(upgradeBoxOrigin);
			upgradeBox
				.clear()
				.rect(
					0, 0,
					upgradeBoxSize.x, upgradeBoxSize.y / 6
				)
				.fill(0x441111)
				.rect(
					0, 0,
					upgradeBoxSize.x, upgradeBoxSize.y
				)
				.stroke(this.unicenter.requestStroke(this.colorHighlight, "NARROW"));

			let upgradeTitle = this.display.upgradeTitle;
			upgradeTitle.style.fontSize = this.unicenter.requestFontSize("LARGE");
			upgradeTitle.text = upgrade.name;
			let upgradeTitleOrigin = new Vector(
				wideMargin,
				(headerHeight - upgradeTitle.height) / 2
			).round();
			upgradeTitle.position.copyFrom(upgradeTitleOrigin);

			this.display.carton.update(
				dt, headerHeight, upgradeBoxOrigin, upgradeBoxSize, upgrade, level
			);

			this._refreshStory(upgradeBoxSize, headerHeight, level);

			let upgradeButtonSize = new Vector(
				upgradeBoxSize.x - 2 * narrowMargin,
				(upgradeBoxSize.y - 2 * narrowMargin) / 3
			).round();
			let upgradeButtonOrigin = new Vector(
				narrowMargin,
				upgradeBoxSize.y - narrowMargin - upgradeButtonSize.y
			);

			let upgradePotential = "";
			let isMaxLevel = (level === upgrade.levels.length - 1);
			let isTooDifficult = !isMaxLevel
				&& upgrade.levels[level + 1].difficulty > this.power;
			if (isMaxLevel) {
				upgradePotential = "Maxed out";
			} else if (isTooDifficult) {
				upgradePotential = "Too difficult"
			} else {
				let costMap = upgrade.levels[level + 1].cost;
				let costString = Array.from(costMap.entries())
					.map(costElement => {
						let costValue = costElement[1];
						let costUnit = RESOURCE_INFO.get(costElement[0])
							.displayName;
						return `${costValue} ${costUnit}`;
					})
					.join(', ');
				upgradePotential = `Upgrade for ${costString}`;
			}
			this.display.upgradeButton.update(
				this.colorBase,
				this.colorHighlight,
				upgradeButtonOrigin,
				upgradeButtonSize,
				upgradePotential
			);
		}
	}

	_refreshStory(upgradeBoxSize, headerHeight, level) {
		let wideMargin = this.unicenter.requestMarginWidth(2);

		let storyOrigin = new Vector(wideMargin, headerHeight + wideMargin);
		let storyWidth = upgradeBoxSize.x - 2 * wideMargin;

		let upgradeStory = this.display.upgradeStory;
		upgradeStory.style.fontSize = this.unicenter.requestFontSize("SMALL");
		upgradeStory.style.wordWrapWidth = storyWidth;
		upgradeStory.position.copyFrom(storyOrigin);

		let levels_info = UPGRADE_INFO.get(this._selectedTech).levels;
		if (level >= levels_info.length - 1) {
			upgradeStory.text = MAXED_OUT_TEXT;
			return;
		}
		if (levels_info[level + 1].difficulty > this.power) {
			upgradeStory.text = NOT_POWERFUL_ENOUGH_TEXT;
			if (this.power > UPGRADER_POWER.BASIC) {
				upgradeStory.text += ` ${NOT_IMPLEMENTED_TEXT}`;
			}
			return;
		}
		upgradeStory.text = levels_info[level + 1].story;
	}

	// Try to upgrade a technology and take away the items accordingly
	// This function does nothing if the upgrade is impossible.
	//
	// Args:
	//   techName - string
	_tryUpgrade(techName) {
		let upgrade = UPGRADE_INFO.get(techName);
		let level = this._levels.get(techName);

		// Max level, upgrade impossible
		if (level === upgrade.levels.length - 1) return;

		// Insufficient power, upgrade impossible
		if (upgrade.levels[level + 1].difficulty > this.power) return;

		let cost = upgrade.levels[level + 1].cost;

		// Insufficient funds, upgrade impossible
		if (!this.unicenter.refinery.canAfford(cost)) return;

		// All checks passed, do the upgrade
		this.unicenter.ship.reportStat("UPGRADES_OBTAINED", 1);
		this._levels.set(techName, this._levels.get(techName) + 1);
		this.unicenter.refinery.deduct(cost);

		this.unicenter.ship.achievements.recordAchievement(ACHIEVEMENTS.UPGRADE);

		// No need to push upgrades anywhere - whatever needs the upgrade is
		// responsible for pulling it using this.getValue().
	}
}
